{
  "clear": "Pobrišite",
  "invalid": "(neveljavno)",
  "loading": "Nalaganje...",
  "noResults": "Ni rezultatov"
}
